import { Box, Typography, useMediaQuery } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { customToast, showApiResponseToast } from '../../utils/customToast'  // Add this line
import ConfirmBusinessInfoSection from './Components/ConfirmBusinessInfoSection';
import { CustomButton } from '../../v2/MUI_custom_component'
import OnboardingContainer from './OnboardingContainer';
import AddressDetailModal from './Components/AddressDetailModal'
import HumbeeModal from '../../v2/MUI_custom_component/Modal/HumbeeModal'
import DataLostSvg from '../Illustrration/components/DataLostSvg'
import IllustrationWrapper from '../Illustrration/IllustrationWrapper'
import NoInventorySvg from '../Illustrration/components/NoInventorySvg'
import { firmOnboardingAction } from './API/Action'
import { buildRoleAdditionRequests, executeRoleAdditionRequests } from './API/roleAdditionUtils';
import DisplaySelectedRole from './Components/DisplaySelectedRole'
import { useLocation, useNavigate } from 'react-router-dom'
import { GetMeAction } from '../Auth/Login/API/Action';
import { refreshTokenAction } from '../../v2/Onboarding/auth/action'
import { toast } from 'react-toastify'
import { fetchSuppliers, resetSuppliers } from '../Common/Entity/actions/reduxActions'

const ConfirmOnboardDetails = () => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const manufacturerRoleFlow = useSelector(state => state.FirmOnboardingReducer.manufacturerRoleFlow);
    const selected_firm = useSelector((state) => state.dashboardReducer.selected_firm);
    const { 
        selected_manufacturer_roles,
        gst_flow,
        gst_details,
        pan_details,
        operational_details,
        existingFirm
    } = useSelector(state => state.FirmOnboardingReducer || {});
    const showHistory = useSelector(state => state.entityReducer.show_history);
    const selectedFirmId = useSelector(state => state.dashboardReducer.selected_firm);
    const location = useLocation();
    const [showDetailModal, setShowDetailModal] = useState(!manufacturerRoleFlow);
    const [loading, setLoading] = useState(false);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [fieldErrors, setFieldErrors] = useState({});
    

    const onEdit = () => {
        setShowDetailModal(true);
    }
    const handleDeleteClick = (manufacturer) => {
        if (!manufacturer?.manufacturer_id) return;
        dispatch({ 
            type: 'REMOVE_MANUFACTURER_ROLE', 
            payload: manufacturer.manufacturer_id 
        });
        const remainingRoles = selected_manufacturer_roles.filter(
            role => role.manufacturer_id !== manufacturer.manufacturer_id
        );
        const hasGstRequired = remainingRoles.some(role => role.is_gst_required);
        dispatch({ type: 'SET_SHOW_GST_INPUT', payload: hasGstRequired });
    }
    const validateAddressDetails = () => {
        const addressData = operational_details;
        const errors = {};

        if (!addressData) {
            errors.address_line_1 = 'Address Line 1 is required';
            errors.state_id = 'State is required';
            errors.district_id = 'District is required';
            errors.pincode_id = 'Pincode is required';
            errors.location_id = 'City is required';
            setFieldErrors(errors);
            return { isValid: false, errors };
        }

        if (!addressData.firm_name?.trim()) {
            errors.firm_name = 'Firm Name is required';
        }

        if (!addressData.address_line_1?.trim()) {
            errors.address_line_1 = 'Address Line 1 is required';
        }

        if (!addressData.state_id) {
            errors.state_id = 'State is required';
        }

        if (!addressData.district_id) {
            errors.district_id = 'District is required';
        }
        if (!addressData.pincode_id) {
            errors.pincode_id = 'Pincode is required';
        }
        if (!addressData.location_id) {
            errors.location_id = 'City is required';
        }
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            return { isValid: false, errors };
        }
        return { isValid: true, errors: {} };
    }
    useEffect(() => {
        validateAddressDetails();
    }, [operational_details]);
    
    useEffect(() => {
        dispatch({ type: 'RESET_MANUFACTURER_ROLE_FLOW' });
    }, []);


    const handleContinue = async() => {
        const { isValid, errors } = validateAddressDetails();
        if (!isValid) {
            setShowDetailModal(true);
            return;
        }

        if (existingFirm) {
            if (!selectedFirmId) {
                customToast.error('Unable to add manufacturer role. Please select a firm and try again.');
                return;
            }
            const roleAdditionRequests = buildRoleAdditionRequests(selected_manufacturer_roles, {
                companyId: (selectedFirmId && existingFirm) ? selectedFirmId : null,
                gst_details,
                pan_details,
                operational_details,
                existingFirm
            });
            setLoading(true);
            const { success } = await executeRoleAdditionRequests(roleAdditionRequests);
            setLoading(false);
            dispatch(fetchSuppliers());
            navigate('/');
            return;
        }

        const registeredAddress = gst_flow ? gst_details : pan_details;
        const payload = {
            company_name: operational_details?.firm_name,
            company_gstin: gst_details?.gst_number || null,
            pancard_no: operational_details?.pan_number || null,
            registered_address: {
                company_address: {
                    address_line_1: registeredAddress?.address_line_1 || operational_details?.address_line_1,
                    address_line_2: registeredAddress?.address_line_2 || null,
                },
                location_id: registeredAddress?.location_id || null ,
                state_id: registeredAddress?.state_id || operational_details?.state_id,
                district_id: registeredAddress?.district_id || operational_details?.district_id,
                pincode: registeredAddress?.pincode_id || null,
            },
            operational_address: {
                company_address: {
                    address_line_1: operational_details?.address_line_1 || null,
                    address_line_2: operational_details?.address_line_2 || null,
                },
                location_id: operational_details?.location_id || null,
                state_id: operational_details?.state_id || null,
                district_id: operational_details?.district_id || null,
                pincode: operational_details?.pincode_id || null,
            },
        };
        setLoading(true);
        const { data, error, message } = await firmOnboardingAction(payload);
        setLoading(false);
        if (!error) {
        if(data && data.response_meta){
            showApiResponseToast(data.response_meta, message, {
                CustomButton,
                toast,
                navigate,
                path: '/my-account/firm-details',
                label: "View"
            });
        }
        dispatch(resetSuppliers());
        const { error: userError, data: loggedInUser } = await GetMeAction();
        const { error: tokenError, data: tokenData } = await refreshTokenAction();
        if (!userError && loggedInUser) {
        if (tokenData) {
                localStorage.setItem('token', tokenData);
                dispatch({ type: 'SET_USER', data: loggedInUser });
                
            }
        }
        dispatch({ type: 'SELECTED_FIRM', payload: data.company_id });
        data.company_id && dispatch(fetchSuppliers());

        const roleAdditionRequests = buildRoleAdditionRequests(selected_manufacturer_roles, {
            companyId: data.company_id,
            gst_details,
            pan_details,
            operational_details,
            existingFirm: true
        });
        const { success } = await executeRoleAdditionRequests(roleAdditionRequests);
        if (!success) return;
            navigate('/');
        } else {
            customToast.error(message);
        }
    }
    
    return (
        <OnboardingContainer 
            title="Confirmation" 
            ShowIcon={true}
            navigation={() => navigate(-1)}
        >
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2
            }}>
            <ConfirmBusinessInfoSection
                isMobile={isMobile}
                gstFlow={gst_flow}
                gstDetails={gst_details}
                panDetails={pan_details}
                operationalDetails={operational_details}
                fieldErrors={fieldErrors}
                onEdit={onEdit}
                editable={true}
            />
            <Box sx={{
                background: '#fff',
                borderRadius: 2,
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 1
            }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="labelD">
                        Manufacturers & Roles
                    </Typography>
                </Box>
                {selected_manufacturer_roles && selected_manufacturer_roles.length > 0 ? (
                    selected_manufacturer_roles.map((role, index) => (
                        <DisplaySelectedRole
                            key={`${role.manufacturer_id}-${index}`}
                            role={role}
                            onDelete={handleDeleteClick}
                        />
                    ))
                ) : (
                    <Box>
                        <IllustrationWrapper
                            titleVariant="h3"
                            subtitleVariant="body1"
                            subtitleStyle = {{color:'#666'}}
                            illustration={<NoInventorySvg />}
                            illustrationProps={{
                                width: 160,
                                height: 132,
                            }}
                        />
                    </Box>
                )}
                <CustomButton
                    label={selected_manufacturer_roles.length > 0 ? "Edit or Add Manufacturer" : "Add Manufacturer"}
                    variant="text"
                    fullWidth
                    onClick={() => {
                        dispatch({ type: 'SET_MANUFACTURER_ROLE_FLOW', payload: true });
                        navigate('/firm-onboarding/select-manufacturer');
                    }}
                />
            </Box>
            <CustomButton
                label="I confirm, let’s proceed!"
                variant="filled"
                fullWidth
                onClick={handleContinue}
                loading={loading}
            />
            <CustomButton
                label="Cancel"
                variant="text"
                fullWidth
                onClick={() => setShowCancelModal(true)}
            />
            <AddressDetailModal
                open={showDetailModal}
                onClose={() => setShowDetailModal(false)}
                initialValidationErrors={fieldErrors}
                firmDetails={{ operational_details, gst_details, pan_details, gst_flow }}
            />
            <HumbeeModal
                open={showCancelModal}
                onClose={()=> setShowCancelModal(false)}
                onConfirm={() => navigate('/')}
                title="Are you sure you want to cancel?"
                subtitle={`All data would be lost.`}
                confirmLabel="Yes"
                cancelLabel="No"
                illustration={<DataLostSvg />}
                width={{ xs: 400 , md:  600 }}
            />
            </Box>
        </OnboardingContainer>
    )
}

export default ConfirmOnboardDetails